import React from "react";
export default React.createClass({
    render: function(){
        let options = this.props.options;
        let inlineCheckbox = false
        if(this.props.inlineCheckbox) {
          inlineCheckbox = true
        }
        return(
            <div id={this.props.field + "-group"} className="form-div row">
              <div className={this.props.bigLabel ? "col-sm-7" : "col-sm-4"}>
                <label className="group-label">{this.props.label}
                {this.props.requiredField &&
                  <span className="requiredField"> * </span>
                }
                </label>
              </div>
              <div className={this.props.bigLabel ? "col-sm-5" : "col-sm-8"}>
                {options.map((object, i) =>
                  <span key={"checkbox-span"+i}>
                  {inlineCheckbox == true &&
                    <span key={i}>
                    <input type="checkbox" name={this.props.field + "[" + options[i].value + "]"} id={this.props.field + options[i].value}  onChange={this.props.change} value={options[i].value} />
                    <label htmlFor={this.props.field + options[i].value} className="radioLabel">{options[i].label} &nbsp;&nbsp;</label>
                    </span>
                  }
                  {inlineCheckbox == false &&
                    <p key={i}>
                      <input type="checkbox" name={this.props.field + "[" + options[i].value + "]"} id={this.props.field + options[i].value}  onChange={this.props.change} value="yes" />
                      <label htmlFor={this.props.field + options[i].value} className="radioLabel">
                        {options[i].label}
                        {options[i].hint && <span className="small-font"> ({options[i].hint})</span> }
                      </label>
                    </p>
                  }
                  </span>
                )}
              </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/check-row.jsx